import { render, staticRenderFns } from "./FailOrder.vue?vue&type=template&id=2f17a223"
import script from "./FailOrder.vue?vue&type=script&lang=js"
export * from "./FailOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports